import { api } from '@sentinel/web-core';
import type {
  Attachment,
  Channel,
  Message,
  MessageCreate,
  MessagePage,
  Participant,
  Receipt,
  StorageUsage,
} from '@sentinel/shared';

const base = (missionId: string) => `/missions/${missionId}`;

/** Comunicazioni of a mission (ADR 0023): channels, threads, receipts, files, space. */
export const communicationEndpoints = {
  channels: (missionId: string) => api<{ items: Channel[] }>(`${base(missionId)}/channels`),
  participants: (missionId: string) =>
    api<{ items: Participant[] }>(`${base(missionId)}/participants`),
  messages: (missionId: string, channelId: string, before?: string) =>
    api<MessagePage>(
      `${base(missionId)}/channels/${channelId}/messages${before === undefined ? '' : `?before=${before}`}`,
    ),
  send: (missionId: string, body: MessageCreate, idempotencyKey: string) =>
    api<Message>(`${base(missionId)}/messages`, { method: 'POST', body, idempotencyKey }),
  read: (missionId: string, channelId: string) =>
    api<{ ok: true }>(`${base(missionId)}/channels/${channelId}/read`, { method: 'POST' }),
  delivered: (missionId: string, messageIds: string[]) =>
    api<{ ok: true }>(`${base(missionId)}/messages/delivered`, {
      method: 'POST',
      body: { messageIds },
    }),
  ack: (missionId: string, messageId: string) =>
    api<{ ok: true }>(`${base(missionId)}/messages/${messageId}/ack`, { method: 'POST' }),
  receipts: (missionId: string, messageId: string) =>
    api<{ items: Receipt[] }>(`${base(missionId)}/messages/${messageId}/receipts`),
  remind: (missionId: string, messageId: string) =>
    api<{ reminded: number }>(`${base(missionId)}/messages/${messageId}/remind`, {
      method: 'POST',
    }),
  upload: (missionId: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api<Attachment>(`${base(missionId)}/attachments`, { method: 'POST', form });
  },
  attachment: (missionId: string, attachmentId: string) =>
    api<Blob>(`${base(missionId)}/attachments/${attachmentId}`, { as: 'blob' }),
  storage: (missionId: string) => api<StorageUsage>(`${base(missionId)}/storage`),
};
